import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { fetchUsuario, getUsuario } from '../../user';

export default function NewSeccion() {
    const [mensaje, setMensaje] = useState('');
    const [seccion, setSeccion] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setSeccion('');
        setMensaje('');
        setModalOpen(!modalOpen);
    };

    const crear = async () => {
        const formData = new FormData();
        formData.append('seccion', seccion);
        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/seccionesPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexion. Por favor, intentelo de nuevo.');
        }
    };

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();
    const alertPermiso = () => {
        Swal.fire(
            'Error',
            'No tienes permisos',
            'error'
        );
    };

    const botonAgregar = (
        <button onClick={toggleModal} className='btnSave'>
            <span>+</span> Seccion
        </button>
    );

    return (
        <div className='NewContain'>
            <ToastContainer />
            {loading ? (
                <></>
            ) : usuarioLegued?.idUsuario ? (
                <>
                    {usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'colaborador' ? botonAgregar : <></>}
                </>
            ) : (
                botonAgregar
            )}
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Seccion</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">
                            <fieldset>
                                <legend>Seccion (*)</legend>
                                <input
                                    type='text'
                                    name='seccion'
                                    value={seccion}
                                    onChange={(e) => setSeccion(e.target.value)}
                                />
                            </fieldset>
                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={usuarioLegued?.rol === 'colaborador' ? alertPermiso : crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
